import type { SectionTabDef } from './types';

export const SECTION_TABS: SectionTabDef[] = [
  { id: 'apiKeys', label: 'API Keys', hint: 'Connect providers' },
  { id: 'application', label: 'Application', hint: 'Behavior and cache' },
  { id: 'additional', label: 'Additional', hint: 'Holiday and labels' }
];

export const STATUS_COLORS = {
  openaiAdmin: {
    active: 'bg-blue-100 text-blue-800 dark:bg-blue-900/40 dark:text-blue-200',
    inactive: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200'
  },
  openaiStandard: {
    active: 'bg-green-100 text-green-800 dark:bg-green-900/40 dark:text-green-200',
    inactive: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200'
  },
  anthropic: {
    active: 'bg-orange-100 text-orange-800 dark:bg-orange-900/40 dark:text-orange-200',
    inactive: 'bg-gray-100 text-gray-700 dark:bg-gray-700 dark:text-gray-200'
  }
} as const;

export const MESSAGE_CLASSES = {
  success: 'bg-green-50 dark:bg-green-900/20 text-green-800 dark:text-green-200 border-green-200 dark:border-green-800',
  error: 'bg-red-50 dark:bg-red-900/20 text-red-800 dark:text-red-200 border-red-200 dark:border-red-800',
  info: 'bg-blue-50 dark:bg-blue-900/20 text-blue-800 dark:text-blue-200 border-blue-200 dark:border-blue-800'
} as const;
